import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  PlusOutlined
} from '@ant-design/icons'
import { Button, Form, Input, Space, Tooltip } from 'antd'
import get from 'lodash.get'
import React, { useEffect, useState } from 'react'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import { addressSearch } from '../../services/postservice'
import FilterForm from './FilterForm'
import FormPost from './FormPost'
import {
  addProject,
  deleteProject,
  detailProject,
  getAll,
  updateProject
} from '../../services/projectservice'
import { ACTION_MODE, PAGE_SIZE_OPTIONS } from '../../configData'
import { hasPermission } from '../../config-func'
import FormAddExcel from './FormAddExcel'
import { debounce } from 'lodash'
import Loading from '../Loading';
const ProjectManagement = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [isModalImportOpen, setIsModalImportOpen] = useState(false)
  // get arr select
  const [cities, setCities] = useState([])
  const [districts, setDistricts] = useState([])
  const [towns, setTowns] = useState([])
  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 10
  })

  const handleSearch = debounce(() => {
    if (filters.currentPage === 1) {
      fetchData()
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 1 }))
    }
  }, 500)

  async function fetchData() {
    setLoading(true)

    let _dataSource = []
    let _total = 0

    try {
      const response = await getAll({
        pageNo: filters.currentPage,
        pageSize: filters.pageSize,
        investor: filters.investor || '',
        project_name: filters.project_name || '',
        city_code: filters.city_code || '',
        district_code: filters.district_code || '',
        town_code: filters.town_code || '',
        address: filters.address || ''
      })

      // if (response?.code === 0) {
      _total = response?.data?.total
      _dataSource = response?.data?.list
      // }
    } catch (error) {
      openNotification(
        'error',
        error?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
      setTotal(_total)
      setDataSource(_dataSource)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filters.currentPage, filters.pageSize, filters.reset])
  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (filters.currentPage - 1) * filters.pageSize + index + 1
    },
    {
      title: 'Chủ đầu tư',
      dataIndex: 'investor',
      key: 'investor',
      width: 200
    },
    {
      title: 'Dự án',
      dataIndex: 'project_name',
      key: 'project_name',
      width: 150
    },

    // { title: 'Quản lý TP', dataIndex: 'name', key: 'name' },

    {
      title: 'Tỉnh/Thành phố',
      dataIndex: 'city_info',
      key: 'city_info',
      width: 150,

      render: (_, record) => {
        return <span>{record?.city_info?.name || 'Đang xác minh'}</span>
      }
    },
    {
      title: 'Quận/huyện',
      dataIndex: 'district_info',
      key: 'district_info',
      width: 150,
      render: (_, record) => {
        return <span>{record?.district_info?.name || 'Đang xác minh'}</span>
      }
    },
    {
      title: 'Phường/Xã',
      dataIndex: 'town_info',
      key: 'town_info',
      width: 150,
      // render: (_, record, index) => {
      //   const name = listDepartment.find(
      //     (n) => n.id === record.department_id
      //   )?.name
      //   return <span>{name}</span>
      // }
      render: (_, record) => {
        return <span>{record?.town_info?.name || 'Đang xác minh'}</span>
      }
    },
    {
      title: 'Đường phố',
      dataIndex: 'address',
      key: 'address',
      width: 150
    },
    {
      title: 'Tin bán',
      dataIndex: 'SELL',
      key: 'SELL',
      width: 120
      // render: (_, record) => (
      //   <span>
      //     {listProject.find((n) => n.id === record.project_id)?.project_name ||
      //       ''}
      //   </span>
      // )
    },
    {
      title: 'Tin thuê',
      dataIndex: 'RENT',
      key: 'RENT',
      width: 120
      // render: (_, record) => (
      //   <span>
      //     {status.find((n) => n.value === record.status)?.label || ''}
      //   </span>
      // )
    },
    {
      title: 'Số tầng',
      dataIndex: 'number_of_floor',
      key: 'number_of_floor',
      width: 120
    },

    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            {hasPermission('P43.2', permissions) && (
              <Tooltip title="Chỉnh sửa">
                <Button
                  style={{ width: 32 }}
                  icon={<EditOutlined />}
                  onClick={() => {
                    setMode(ACTION_MODE.UPDATE)
                    getDetailProject(record.id)
                  }}
                />
              </Tooltip>
            )}
            {hasPermission('P43.3', permissions) && (
              <Tooltip title="Xóa">
                <Button
                  style={{ width: 32 }}
                  icon={<DeleteOutlined style={{ color: 'red' }} />}
                  onClick={() =>
                    showConfirm({
                      title: 'Xác nhận xoá',
                      content: (
                        <div>
                          Bạn có chắc chắn muốn xoá thư viện dự án
                          <b> {record.project_name}</b> không?
                        </div>
                      ),
                      onOk: () => handleDeleteProject(record.id)
                    })
                  }
                />
              </Tooltip>
            )}
          </Space>
        )
      }
    }
  ]

  // Thêm sửa project
  const handleSave = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      const { id, ...data } = values
      const res =
        mode == ACTION_MODE.ADD
          ? await addProject(data)
          : await updateProject(data, id)

      form.resetFields()
      setIsModalOpen(false)
      fetchData()
      openNotification(
        'success',
        mode == ACTION_MODE.ADD
          ? 'Tạo mới thư viện dự án thành công !'
          : 'Cập nhật thư viện dự án thành công'
      )
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  // Xóa project
  const handleDeleteProject = async (ids) => {
    setLoading(true)
    const body = {
      ids: [ids]
    }
    try {
      const res = await deleteProject(body || [])
      fetchData()
      openNotification('success', res.message)
    } catch (err) {
      console.error('Error creating product:', err)
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  // Chi tiết dự án
  const getDetailProject = async (id) => {
    setLoading(true)
    try {
      const res = await detailProject(id) // Assuming roleSearch is an API function

      if (res && res.data) {
        setIsModalOpen(true)
        const values = res.data
        form.setFieldsValue({
          ...values
        })
        getListDistricts(values.city_code)
        getListTowns(values.district_code)
      } else {
        openNotification('error', 'Có lỗi xảy ra, Vui lòng thử lại')
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
    }
  }
  // Danh sách thành phố
  const getListCities = async () => {
    try {
      const res = await addressSearch('', 'city')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setCities(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }
  // Danh sách quận huyện
  const getListDistricts = async (i) => {
    const params = {
      parent_code: i
    }
    try {
      const res = await addressSearch(params, 'district')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setDistricts(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }
  // Danh sách phường xã
  const getListTowns = async (code) => {
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'town')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setTowns(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  useEffect(() => {
    getListCities()
  }, [])

  const onChangeCity = (e) => {
    getListDistricts(e)
    form.setFieldsValue({
      district_code: null,
      town_code: null
    })
  }
  const onChangeDistrict = (e) => {
    const code = districts.filter((item) => item.code == e)?.[0]?.code
    getListTowns(code)
    form.setFieldsValue({
      town_code: null
    })
  }

  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <FilterForm
          handleSearch={handleSearch}
          cities={cities}
          districts={districts}
          towns={towns}
          onChangeCity={onChangeCity}
          onChangeDistrict={onChangeDistrict}
          setFilters={setFilters}
          fetchData={fetchData}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* <h2 className="text-2xl font-semibold my-2">Quản lý dự án</h2> */}
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            {/* <Button
              type="primary"
              key="primary"
              onClick={() => {
                setIsModalImportOpen(true)
              }}
            >
              <PlusOutlined /> Import Excel
            </Button> */}

            {hasPermission('P43.4', permissions) && (
              <Button
                type="primary"
                key="primary"
                onClick={() => {
                  setIsModalImportOpen(true)
                }}
              >
                <PlusOutlined /> Import Excel
              </Button>
            )}

            {hasPermission('P43.1', permissions) && (
              <Button
                type="primary"
                // htmlType="submit"
                onClick={() => {
                  setIsModalOpen(true)
                  setMode(ACTION_MODE.ADD)
                }}
              >
                <PlusOutlined />
                Thêm mới
              </Button>
            )}
          </div>
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          // locale={{
          //   emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
          //   triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
          //   triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
          //   cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          // }}

          // columns={
          //   filters.isDefault === 'fixed'
          //     ? columns.filter(
          //         (item) => !['calculationMethod'].includes(item.dataIndex)
          //       )
          //     : columns.filter(
          //         (item) => !['isDefault'].includes(item.dataIndex)
          //       )
          // }

          pagination={{
            current: filters.currentPage,
            pageSize: filters.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                currentPage: 1
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, currentPage: page }))
            },
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            locale: { items_per_page: 'bản ghi / trang' }
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE ? 'Chỉnh sửa dự án' : 'Thêm mới dự án'
        }
        visible={isModalOpen}
        centered
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
      >
        <FormPost
          form={form}
          handleSearch={handleSearch}
          cities={cities}
          districts={districts}
          towns={towns}
          onChangeCity={onChangeCity}
          onChangeDistrict={onChangeDistrict}
        />
      </ModalCustom>
      <FormAddExcel
        isModalOpen={isModalImportOpen}
        setIsModalOpen={setIsModalImportOpen}
        fetchApiList={fetchData}
      />
      <ModalConfirm />
    </div>
  )
}

export default ProjectManagement
